// @ts-check
import { BottleImagePlaceholder, Box, Image } from '~/design-system';

export default function BrandLogo({ brand }) {
  return (
    <Image
      fixed={brand?.logo?.fixed}
      alt={brand?.name}
      sx={{ display: 'block', overflow: 'hidden', marginY: 2 }}
      fallback={<Box sx={{ width: 80, height: 80 }} />}
    />
  );
}

export function BrandLogoSkeleton({ alt = '', ...rest }) {
  return (
    <BottleImagePlaceholder
      alt={alt}
      sx={{ display: 'block', width: 80, height: 80, marginY: 2 }}
      {...rest}
    />
  );
}
